import React, { Component } from "react";
import TweenLite from "gsap/umd/TweenMax";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import SliderArrow from "./../../components/SliderArrow";

// Components
import "./style.css";

class SlideShow extends Component {
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: <SliderArrow direction="next" />,
            prevArrow: <SliderArrow direction="prev" />,
            afterChange: slide => {
                // Animate the pagination dots
                const node = document.getElementsByClassName("slick-dots")[0];
                const move =
                    slide === 0 || slide === 1
                        ? "5px"
                        : `-${30 * (slide - 1)}px`;

                TweenLite.to(node.firstChild, 0.3, {
                    "margin-left": `${move}`
                });
            }
        };

        const baseUrl =
            "https://res.cloudinary.com/kirkesok/image/upload/w_700";

        const { images } = this.props;

        return (
            <Slider {...settings}>
                {images.map((data, index) => {
                    return (
                        <div key={index}>
                            <a
                                target="_blank"
                                href={`${baseUrl}/v${data.version}/${data.public_id}.jpg`}
                                title="Åpne bildet i ny fane"
                            >
                                <img
                                    src={`${baseUrl}/v${data.version}/${data.public_id}.jpg`}
                                    alt={
                                        data &&
                                        data.context &&
                                        data.context.custom.alt
                                    }
                                />
                            </a>
                        </div>
                    );
                })}
            </Slider>
        );
    }
}

export default SlideShow;



// WEBPACK FOOTER //
// ./src/components/SlideShow/index.js